import { Component, EventEmitter, Input, KeyValueDiffer, KeyValueDiffers, OnInit, Output } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { ManualRowSortComponent } from 'src/app/dashboards/components/manual-row-sort/manual-row-sort.component';
import { SortComponent } from 'src/app/dashboards/components/sort-component/sort.component';
import { queue } from 'src/app/dashboards/models';
import { canculateGridItemSize, register } from 'src/app/dashboards/widget/widget-helpers/helpers';
import { WidgetBaseComponent } from 'src/app/dashboards/widget/widgets/widget-base.component';
import { widgetType } from 'src/app/enums';
import { gridItem, property } from 'src/app/models';
import { DashboardService } from 'src/app/services/services/dashboard.service';

@Component({
    selector: 'app-queues-wizard',
    templateUrl: './queues-wizard.component.html',
    styleUrls: ['./queues-wizard.component.scss'],
    standalone: false
})
@register("Queues_wizard")
export class QueueswizardComponent implements OnInit, WidgetBaseComponent {
  @Input() public gridItem: gridItem;
  @Input() public isEdit: boolean;
  @Output() public completed = new EventEmitter<boolean>();
  queues$: Observable<queue[]>;
  queueProperties$: Observable<property[]>;
  queueProperties: property[];
  visualTypedisabledItems: number[] = [];
  queues: queue[];
  manualRowOrderItems: queue[];
  private queueIdDiffers: KeyValueDiffer<string, any>;

  get isManualRowOrderEnabled(): boolean {
    let isManualRowSortEnabled = ManualRowSortComponent.getIsManualRowSortEnabled(this.gridItem);

    this.nulifySetupSortingPoperties(isManualRowSortEnabled);

    return isManualRowSortEnabled;
  }

  get isSecondLevelSortingEnabled() {
    return !!this.gridItem.setup[SortComponent.firstLevelSetupColumnPropertyName];
  }

  get isSortingVisible() {
    let queuesCount = this.gridItem.setup.queueIds?.length || 0;
    let propsCount = this.gridItem.setup.queuePropertiesIds?.length || 0;

    return this.gridItem.type == 4 && queuesCount > 0 && propsCount > 0;
  }

  constructor(private DashboardsService: DashboardService, private i18nextPipe: I18NextPipe, private differs: KeyValueDiffers) { }

  ngOnInit(): void {
    this.queues$ = this.DashboardsService.getAllQueues();
    this.queueProperties$ = this.DashboardsService.getQueueProperties();
    this.queueProperties$.pipe(take(1)).subscribe(p => {
      this.queueProperties = p;
    });
    setTimeout(() => this.modelChange(), 0);

    this.queueIdDiffers = this.differs.find(this.gridItem).create();

    this.queues$.subscribe(queues => {
      this.queues = queues;
      this.setManualOrderItems();
    });
  }

  // gridItem is changed on deeper level so it cannot be detected by ngOnChanges
  ngDoCheck(): void {
    const changes = this.queueIdDiffers.diff(this.gridItem.setup.queueIds);

    if (changes && this.queues && this.queues.length) {
      this.setManualOrderItems();
    }
  }

  setManualOrderItems() {
    let queueIds: number[] = this.gridItem.setup.queueIds || [];
    this.manualRowOrderItems = this.queues.filter(queue => queueIds.includes(queue["id"]));
  }

  nulifySetupSortingPoperties(isManualRowSortEnabled: boolean) {
    if (isManualRowSortEnabled) {
      this.gridItem.setup[SortComponent.firstLevelSetupColumnPropertyName] = null;
      this.gridItem.setup[SortComponent.firstLevelSetupDirectionPropertyName] = null;
      this.gridItem.setup[SortComponent.secondLevelSetupColumnPropertyName] = null;
      this.gridItem.setup[SortComponent.secondLevelSetupDirectionPropertyName] = null;
    } else {
      this.gridItem.setup[ManualRowSortComponent.setupPropertyName] = null;
    }
  }

  modelChange() {
    let listOfStringProp: string[] = ["Description", "OpenForWebAccess"];

    let queuesCount = this.gridItem.setup.queueIds?.length || 0;
    let propsCount = this.gridItem.setup.queuePropertiesIds?.length || 0;
    this.visualTypedisabledItems = [];

    let hasString: boolean = false;
    for (let i = 0; i < this.gridItem.setup.queuePropertiesIds?.length; i++) {
      let propName = this.queueProperties?.find(p => p.id == this.gridItem.setup.queuePropertiesIds[i]).name;
      if (listOfStringProp.indexOf(propName) > -1) {
        hasString = true;
        break;
      }
    }

    if (queuesCount === 1 && propsCount === 1) {
      this.visualTypedisabledItems = [0, 1, 2, 4];
    } else if (queuesCount > 1 && propsCount === 1) {
      if (hasString) {
        this.visualTypedisabledItems = [0, 1, 2];
      }
    } else if (queuesCount > 1 && propsCount > 1 && propsCount <= 4) {
      if (hasString) {
        this.visualTypedisabledItems = [0, 1, 2];
      }
      this.visualTypedisabledItems.push(3);
    } else if (queuesCount > 1 && propsCount > 4) {
      this.visualTypedisabledItems = [0, 1, 2, 3];
    } else if (queuesCount === 1 && propsCount > 1) {
      this.visualTypedisabledItems = [0, 1, 2];
    }

    if (this.visualTypedisabledItems.indexOf(this.gridItem.type) > -1) {
      this.gridItem.type = null;
    }

    if (!this.isEdit) {
      canculateGridItemSize(this.gridItem, Math.max(1, queuesCount, propsCount));
    }

    if (this.isEdit && this.gridItem.type === widgetType.Label) {
      canculateGridItemSize(this.gridItem, Math.max(1, queuesCount, propsCount));
    }

    let completed = queuesCount > 0 && propsCount > 0 && this.gridItem.type != null;
    this.completed.emit(completed);
  }
}
